import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// size 只開三級（見 docs/idol-online-plan.md §5.3），不讓呼叫端自由指定標籤，避免長出新的層級
const SIZE_TAGS = {
  sm: 'h6',
  md: 'h5',
  lg: 'h4',
};

/**
 * 偶像名稱：暱稱 + 官方勾勾
 *
 * - sm（h6 16px）：列表列、留言、聊天室列表；單行截斷
 * - md（h5 20px）：IdolCard、聊天室上方標題；單行截斷
 * - lg（h4 24px）：IdolPage 主標；可換行、不截斷
 *
 * 勾勾與名稱間距統一 gap-1，勾勾隨名稱字級縮放。不負責連結，需要時由呼叫端包 <a>／<Link>。
 * 截斷需要外層給出寬度上限（flex 子項請加 min-w-0）。
 *
 * @param {String} name - 偶像暱稱
 * @param {Boolean} isOfficial - 是否為官方偶像
 * @param {'sm'|'md'|'lg'} size - 字級
 * @param {String} className - 額外類名（顏色、外距等）
 */
function IdolName({ name, isOfficial, size = 'sm', className = '' }) {
  const Tag = SIZE_TAGS[size];
  const nameClass = size === 'lg' ? 'break-anywhere' : 'text-truncate';

  return (
    <Tag className={`d-flex align-items-center gap-1 min-w-0 mb-0 ${className}`}>
      <span className={`min-w-0 ${nameClass}`}>{name}</span>
      {isOfficial && (
        <FontAwesomeIcon icon={['fas', 'circle-check']} className="text-primary flex-shrink-0" />
      )}
    </Tag>
  );
}

IdolName.propTypes = {
  name: PropTypes.string.isRequired,
  isOfficial: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default IdolName;
